import EpicLogin from "./EpicMountainRewards/Login";
import GroupLogin from "./Group/Login";

function Login({
  onSuccessfulLogin,
  showEpic = false,
  showGroup = true,
}: {
  onSuccessfulLogin: (profileType?: string, successMsg?: string) => void;
  showEpic?: boolean;
  showGroup?: boolean;
}) {
  return (
    <div className="flex flex-col divide-y divide-gray-400">
      {showEpic && <EpicLogin className="pb-8" onSuccessfulLogin={onSuccessfulLogin} />}
      {showGroup && <GroupLogin className="pt-4" onSuccessfulLogin={onSuccessfulLogin} />}
    </div>
  );
}

export default Login;
